var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.369 175.623A775951.446 775951.446 0 0 1 79.355 6.028C69.372-.565 57.886-1.429 47.962 1.93l254.05 254.05 80.357-80.357z",
    fill: "#32bbff",
    "data-original": "#32bbff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.962 1.93c-1.86.63-3.67 1.39-5.401 2.308C31.602 10.166 23.549 21.573 23.549 36v439.96c0 14.427 8.052 25.834 19.012 31.761a36.954 36.954 0 0 0 5.395 2.314L302.012 255.98 47.962 1.93z",
    fill: "#32bbff",
    "data-original": "#32bbff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.012 255.98 47.956 510.035c9.927 3.384 21.413 2.586 31.399-4.103 143.598-80.41 237.986-133.196 298.152-166.746l4.938-2.772-80.433-80.434z",
    fill: "#32bbff",
    "data-original": "#32bbff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.549 255.98v219.98c0 14.427 8.052 25.834 19.012 31.761a36.954 36.954 0 0 0 5.395 2.314L302.012 255.98H23.549z",
    fill: "#2c9fd9",
    "data-original": "#2c9fd9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.355 6.028C67.5-1.8 53.52-1.577 42.561 4.239l255.595 255.596 84.212-84.212A786009.366 786009.366 0 0 1 79.355 6.028z",
    fill: "#29cc5e",
    "data-original": "#29cc5e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.158 252.126 42.561 507.721c10.96 5.815 24.939 6.151 36.794-1.789 143.598-80.41 237.986-133.196 298.152-166.746l4.938-2.772-84.287-84.288z",
    fill: "#d93f21",
    "data-original": "#d93f21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M488.45 255.98c0-12.19-6.151-24.492-18.342-31.314 0 0-22.799-12.721-92.682-51.809l-83.123 83.123 83.204 83.205c69.116-38.807 92.6-51.892 92.6-51.892 12.192-6.821 18.343-19.123 18.343-31.313z",
    fill: "#ffd500",
    "data-original": "#ffd500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M470.108 287.294c12.191-6.822 18.342-19.124 18.342-31.314H294.303l83.204 83.205c69.117-38.806 92.601-51.891 92.601-51.891z",
    fill: "#fa0",
    "data-original": "#ffaa00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/google-play-store.0c602875c34a3022b77e2e7b1e05b161.svg";
export { ForwardRef as ReactComponent };